module.exports = __webpack_public_path__ + "img/device_icon_title_grey.6991270a.svg";